import dynamic from 'next/dynamic';
import { Cookiebot } from './components/Cookiebot';
import CustomerSourceAnalytics from './components/CustomerSourceAnalytics';

const ClarityMicrosoft = dynamic(() => import('./components/ClarityMicrosoft'), {
  ssr: false,
});

const CustomerIoAnalytics = dynamic(() => import('./components/CustomerIoAnalytics'), {
  ssr: false,
});

const FacebookPixel = dynamic(() => import('./components/FacebookPixel'), {
  ssr: false,
});

const TiktokPixel = dynamic(() => import('./components/TiktokPixel'), {
  ssr: false,
});

const XPixel = dynamic(() => import('./components/XPixel'), {
  ssr: false,
});

const AhrefsAnalytics = dynamic(() => import('./components/AhrefsAnalytics'), {
  ssr: false,
});

const GoogleAnalyticsConsent = dynamic(() => import('./components/GoogleAnalyticsConsent'), {
  ssr: false,
});

const GoogleTagManager = dynamic(() => import('./gtm/components/GoogleTagManager'), {
  ssr: false,
});

const GTMUserSync = dynamic(() => import('./gtm/components/GTMUserSync'), {
  ssr: false,
});

const FingerprintAnalytics = dynamic(() => import('./components/FingerprintProvider'), {
  ssr: false,
});

const SeonAnalytics = dynamic(() => import('./components/SeonAnalytics'), {
  ssr: false,
});

export default function Analytics() {
  return (
    <>
      <Cookiebot />
      <GTMUserSync />
      <GoogleTagManager />
      <CustomerIoAnalytics />
      <ClarityMicrosoft />
      <CustomerSourceAnalytics />
      <TiktokPixel />
      <XPixel />
      <FacebookPixel />
      <AhrefsAnalytics />
      <GoogleAnalyticsConsent />
      <FingerprintAnalytics />
      <SeonAnalytics />
    </>
  );
}
